import * as _ from 'lodash'
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";

export class UserSecurityService {

    static async getResponsibleUserList(customerWbID: number,
                                        periodWbID: number,
                                        requiredRole_any_one?: string[],
                                        requiredRole2_any_one?: string[],
                                        approvalLimitThreshold?: number): Promise<number[]> {

        if (_.isEmpty(requiredRole_any_one)) {
            requiredRole_any_one = [];
        }
        if (_.isEmpty(requiredRole2_any_one)) {
            requiredRole2_any_one = [];
        }

        let authUserWbIDs: number[];

        let whereJSON: any = {};
        whereJSON.and = [];
        let whereFieldSpecJSON: any = {};
        whereJSON.WB_CUST_ID = customerWbID;
        whereFieldSpecJSON.WB_CUST_ID = {type: "number"};
        whereFieldSpecJSON.ROLE_ID = {type: "string"};

        if (!_.isEmpty(requiredRole_any_one)) {
            whereJSON.and.push({ROLE_ID: {inq: requiredRole_any_one}});
        }

        if (!_.isEmpty(requiredRole2_any_one)) {
            whereJSON.and.push({ROLE_ID: {inq: requiredRole2_any_one}});
        }

        let results = await PASearch.find("vUI_UserRoles_All",
            whereJSON,
            whereFieldSpecJSON,
            [], 0,
            []);

        if (_.isArray(results) && !_.isEmpty(results)) {
            authUserWbIDs = _.uniq(_.map(results, (aRow) => {
                return aRow.WB_AUTHUSR_ID
            }))
        } else {
            authUserWbIDs = [];
        }

        return authUserWbIDs;
    }

    static async getResponsibleUserListWithPlanManagement(customerWbID: number,
                                                          periodWbID: number,
                                                          requiredRole_any_one?: string[],
                                                          requiredRole2_any_one?: string[],
                                                          approvalLimitThreshold?: number,
                                                          planManagementWbIDs?: number[]): Promise<number[]> {
        if (_.isEmpty(requiredRole_any_one)) {
            requiredRole_any_one = [];
        }
        if (_.isEmpty(requiredRole2_any_one)) {
            requiredRole2_any_one = [];
        }

        let authUserWbIDs: number[];

        let whereJSON: any = {};
        whereJSON.and = [];
        let whereFieldSpecJSON: any = {};
        whereJSON.WB_CUST_ID = customerWbID;
        whereFieldSpecJSON.WB_CUST_ID = {type: "number"};
        whereFieldSpecJSON.WB_PLNMGMT_ID = {type: "number"};
        whereFieldSpecJSON.ROLE_ID = {type: "string"};

        if (!_.isEmpty(requiredRole_any_one)) {
            whereJSON.and.push({ROLE_ID: {inq: requiredRole_any_one}});
        }

        if (!_.isEmpty(requiredRole2_any_one)) {
            whereJSON.and.push({ROLE_ID: {inq: requiredRole2_any_one}});
        }

        if (_.isArray(planManagementWbIDs) && !_.isEmpty(planManagementWbIDs)) {
            whereJSON.WB_PLNMGMT_ID = {inq: planManagementWbIDs};
        }

        let results = await PASearch.find("vUI_PlnMgmt_UserRoles_All",
            whereJSON,
            whereFieldSpecJSON,
            [], 0,
            []);

        if (_.isArray(results) && !_.isEmpty(results)) {
            authUserWbIDs = _.uniq(_.map(results, (aRow) => {
                return aRow.WB_AUTHUSR_ID
            }))
        } else {
            authUserWbIDs = [];
        }

        return authUserWbIDs;
    }

    static async getCustomerList(requiredRole_any_one?: string[],
                                 requiredRole2_any_one?: string[]): Promise<number[]> {

        if (_.isEmpty(requiredRole_any_one)) {
            requiredRole_any_one = [];
        }
        if (_.isEmpty(requiredRole2_any_one)) {
            requiredRole2_any_one = [];
        }

        let custWbIDs: number[];

        let whereJSON: any = {};
        whereJSON.and = [];
        let whereFieldSpecJSON: any = {};
        whereFieldSpecJSON.ROLE_ID = {type: "string"}

        if (!_.isEmpty(requiredRole_any_one)) {
            whereJSON.and.push({ROLE_ID: {inq: requiredRole_any_one}});
        }

        if (!_.isEmpty(requiredRole2_any_one)) {
            whereJSON.and.push({ROLE_ID: {inq: requiredRole2_any_one}});
        }

        let results = await PASearch.find("vUI_PlnMgmt_UserRoles_All",
            whereJSON,
            whereFieldSpecJSON,
            [], 0,
            []);

        if (_.isArray(results) && !_.isEmpty(results)) {
            custWbIDs = _.uniq(_.map(results, (aRow) => {
                return aRow.WB_CUST_ID
            }))
        } else {
            custWbIDs = [];
        }

        return custWbIDs;
    }

    static async getPlanMangementList(requiredRole_any_one?: string[],
                                      requiredRole2_any_one?: string[]): Promise<number[]> {
        if (_.isEmpty(requiredRole_any_one)) {
            requiredRole_any_one = [];
        }
        if (_.isEmpty(requiredRole2_any_one)) {
            requiredRole2_any_one = [];
        }

        let plnMgmtWbIDs: number[];

        let whereJSON: any = {};
        whereJSON.and = [];
        let whereFieldSpecJSON: any = {
            ROLE_ID: {type: "string"},
            WB_AUTHUSR_ID: {type: "number"}};

        let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if(usrContext && usrContext.User){
            whereJSON.and.push({WB_AUTHUSR_ID: usrContext.User.cif.WB_AUTHUSR_ID})
        } else {
            whereJSON.and.push({WB_AUTHUSR_ID: -999})
        }

        // TODO: Albert, This needed to be fixed.. This is an and condition.. not this type..
        //   more like an Exists (select 1 from vUsrRoleRel where Role in ..)..
        //   challenging part, is how do you do that in the search service.
        //
        if (!_.isEmpty(requiredRole_any_one)) {
            whereJSON.and.push({ROLE_ID: {inq: requiredRole_any_one}});
        }

        if (!_.isEmpty(requiredRole2_any_one)) {
            whereJSON.and.push({ROLE_ID: {inq: requiredRole2_any_one}});
        }

        let results = await PASearch.find("vUI_PlnMgmt_UserRoles_All",
            whereJSON,
            whereFieldSpecJSON,
            [], 0,
            ['WB_PLNMGMT_ID']);

        if (_.isArray(results) && !_.isEmpty(results)) {
            plnMgmtWbIDs = _.uniq(_.map(results, (aRow) => {
                return aRow.WB_PLNMGMT_ID
            }))
        } else {
            plnMgmtWbIDs = [];
        }

        return plnMgmtWbIDs;
    }

    static async getUserGroupPlanList(): Promise<number[]> {
        let planIds: number[];

        let whereJSON: any = {};
        whereJSON.and = [];
        let whereFieldSpecJSON: any = {
            WB_SALESORG_ID: {type: "number"},
            WB_USRGRP_ID: {type: "number"}};

        let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if(usrContext && usrContext.User){
            whereJSON.and.push({WB_SALESORG_ID: {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID') } })
            whereJSON.and.push({WB_USRGRP_ID: {inq: _.map(usrContext.UserGroups, 'WB_USRGRP_ID') } })
        } else {
            whereJSON.and.push({WB_SALESORG_ID: -999})
            whereJSON.and.push({WB_USRGRP_ID: -999})
        }

        let results = await PASearch.find("vUI_UsrGrp_Plans",
            whereJSON,
            whereFieldSpecJSON,
            [], 0,
            ['WB_PLAN_ID']);

        if (_.isArray(results) && !_.isEmpty(results)) {
            planIds = _.uniq(_.map(results, (aRow) => {
                return aRow.WB_PLAN_ID
            }))
        } else {
            planIds = [];
        }

        return planIds;
    }

}
